module.exports = __webpack_public_path__ + "static/media/purple-arrow-down.03262b28.svg";